import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useFetchPrescriptionUnappliedCashCheck(parameters, isEnabled) {
  const { oktaAuth } = useOktaAuth();

  const dataKey = "useFetchPrescriptionUnappliedCashCheck";

  async function FetchPrescriptionCheckDetails() {
    const accessToken = oktaAuth.getAccessToken();

    var result = await axios
      .get("api/PaymentException/GetUnappliedCashCheckDetails", {
        params: parameters,
        headers: { Authorization: `Bearer ${accessToken}` },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw new Error(error);
      });

    return result;
  }

  return useQuery({
    queryKey: [dataKey, parameters],
    queryFn: async () => await FetchPrescriptionCheckDetails(),
    enabled: isEnabled,
    refetchOnWindowFocus: false
  });
}
